import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/pass/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param searchSkiPassPeriodPrices
   * @returns {AxiosPromise}
   */
  searchAvailableSkiPassPrices(searchSkiPassPeriodPrices) {
    return conduit.post('search-available-prices', { searchSkiPassPeriodPrices });
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-pass-service.js